import { Navigate } from 'react-router-dom';

const HousingInfoPage = () => <Navigate to="/lab/lab_2/maps/housing" replace />;

export default HousingInfoPage;
